import { EDITION_CATEGORY_PAGE } from "@/settings/constant";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useInactiveEditionCheck } from "../components/content/InactiveEditionDialog";
import { getCategoryPath, getDirectChildren, isLastDepthCategory } from "../utils/categoryTree";
import { useEditionCategory } from "./useEditionCategory";
import { useEditionCategoryInfo } from "./useEditionCategoryInfo";
/**
 * 에디션 카테고리 데이터를 조회하고 파생값을 계산하는 훅
 * - 카테고리 트리 API + 카테고리 정보 API
 * - 파생값: lnbItems, lnbTitle, isFirstDepth, isLastDepthByTree 등
 * - 사이드이펙트: 404 리다이렉트, 첫 카테고리 자동 선택, 종료된 기획전 체크
 */ export const useEditionCategoryData = (editionId, selectedCategoryId)=>{
    var _categoryData_depthItems;
    const router = useRouter();
    // API 호출
    const { data: categoryData , isLoading , isFetching , isError: isCategoryError , error: categoryError  } = useEditionCategory(editionId);
    const { data: categoryInfo , isLoading: isCategoryInfoLoading  } = useEditionCategoryInfo(editionId);
    // 종료된 기획전 다이얼로그 체크
    useInactiveEditionCheck(categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.isActive, isCategoryInfoLoading);
    // editionId가 존재하지 않으면 (리스트 API 404) 404 페이지로 이동
    // isFetching 체크: editionId가 변경되어 새 요청이 진행 중일 때는 리다이렉트하지 않음
    useEffect(()=>{
        if (!isLoading && !isFetching && isCategoryError) {
            var _categoryError_response;
            const status = categoryError === null || categoryError === void 0 ? void 0 : (_categoryError_response = categoryError.response) === null || _categoryError_response === void 0 ? void 0 : _categoryError_response.status;
            if (status === 404) {
                router.replace("/404");
            }
        }
    }, [
        isLoading,
        isFetching,
        isCategoryError,
        categoryError,
        router
    ]);
    // 카테고리 파생 데이터
    const firstDepthCategory = categoryData === null || categoryData === void 0 ? void 0 : (_categoryData_depthItems = categoryData.depthItems) === null || _categoryData_depthItems === void 0 ? void 0 : _categoryData_depthItems[0];
    const firstCategoryId = firstDepthCategory === null || firstDepthCategory === void 0 ? void 0 : firstDepthCategory.categoryId;
    const lnbItems = (firstDepthCategory === null || firstDepthCategory === void 0 ? void 0 : firstDepthCategory.items) || [];
    const lnbTitle = (firstDepthCategory === null || firstDepthCategory === void 0 ? void 0 : firstDepthCategory.title) || "";
    const isFirstDepth = !selectedCategoryId || selectedCategoryId === firstCategoryId;
    const isLastDepthByTree = isLastDepthCategory(selectedCategoryId, lnbItems);
    const directChildCategories = getDirectChildren(selectedCategoryId, lnbItems);
    const categoryPath = getCategoryPath(selectedCategoryId, lnbItems);
    // categoryId 없으면 첫 번째 카테고리로 리다이렉트
    useEffect(()=>{
        if (!router.isReady) return;
        if (!selectedCategoryId && firstCategoryId) {
            router.replace("".concat(EDITION_CATEGORY_PAGE, "/").concat(editionId, "?id=").concat(firstCategoryId));
        }
    }, [
        router.isReady,
        selectedCategoryId,
        firstCategoryId
    ]);
    return {
        // API 상태
        categoryInfo,
        isLoading,
        isCategoryError,
        // 파생 데이터
        firstCategoryId,
        lnbItems,
        lnbTitle,
        isFirstDepth,
        isLastDepthByTree,
        directChildCategories,
        categoryPath
    };
};
